import React from 'react';
import Dashboard from '../components/dashboard/Dashboard';

const DashboardPage = () => {
  return <Dashboard />;
};

export default DashboardPage;